/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import './ToggleSwitch.scss';

interface IToggleSwitch{
  onChange?:any;
  checked?:boolean;
}
const ToggleSwitch = ({ onChange, checked }:IToggleSwitch) => (

  <div>
    {' '}
    <label className="switch">
      <input type="checkbox" onChange={(e) => onChange(e?.target?.checked)} checked={checked} />
      <span className="slider round" />
    </label>

  </div>

);
export default ToggleSwitch;
